import { render, staticRenderFns } from "./RecipesByMeal.vue?vue&type=template&id=78a410a0"
import script from "./RecipesByMeal.vue?vue&type=script&lang=js"
export * from "./RecipesByMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports